import { GameID, GameIDType } from '@/enums/gameId';
import { DetailedGameRound } from '@/models/detailed-round';

export function getMultiplier(round: DetailedGameRound, gameId: GameIDType) {
  switch (gameId?.toString()) {
    case GameID.Slide?.toString():
      return `${round?.roulette?.tile?.multiplier.toNumberString()}x`;
    case GameID.Crash?.toString():
    case GameID.CrashTrenball?.toString():
      return `${round?.crash?.crashpoint?.toNumberString()}x`;
    case GameID.Double?.toString():
    case GameID.Frost?.toString():
      return `${round?.roulette?.tile?.multiplier.toNumberString()}x`;
  }
}
